import { put, call, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';

import * as Api from 'api';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';

/***************************** Selectors ************************************/

export const getUsers = state => (state.users);
export const getRoles = state => (state.roleManagement)

/***************************** Subroutines ************************************/


function * initTasks() {
	try {
		const { user } = yield select(getUsers);
		const tasks = yield call(Api.getUsersTasks, null);
		yield put(Actions.initTasksAssignedToMe(tasks.filter(t => t.assigned_to ? t.assigned_to._id == user._id : false)));
		yield put(Actions.initTasksAssignedByMe(tasks.filter(t => t.assigned_by ? t.assigned_by._id == user._id : false)));
	}
	catch(e) {
		console.log(e)
	}
}

function * newTaskSuccess(action) {
	try {
		const new_task = action.payload.task;
		const { user } = yield select(getUsers);

		if(new_task.assigned_to._id == user._id) {
			yield put(Actions.addNewTaskAssignedToMe(new_task));
		}
		if(new_task.assigned_by._id == user._id) {
			yield put(Actions.addNewTaskAssignedByMe(new_task));
			yield put(Actions.notify(
				{ message : 'Task successfully assigned.', title : 'Success!' },
				{ type : 'success' }
			));
		}
		if(new_task.client) {
			yield put(Actions.newClientTask(new_task));
		}
	}
	catch(ex) {
		console.log('ERROR : ', ex.message || ex)
	}
}

function * updateTask({ payload: task }) {
	try {
		yield put(Actions.toggleUpdatingTask(true));
		yield put(Actions.sendSocketEmit(task, 'edit-task'));
	}
	catch(ex) {
		yield call(eventFailed, { payload: ex });
	}
}

function * deleteTaskSuccess(action) {
	const { task_id } = action.payload;
	try {
		yield put(Actions.deleteTask(task_id));
	}
	catch(ex) {
		console.log('ERROR = ', ex.message || ex)
	}
}

function * taskUpdateSuccess(action) {
	let { task } = action.payload;
	try {
		yield put(Actions.updateTask(task));
	}
	catch(ex) {
		yield call(eventFailed, { payload: ex });
	}
	finally {
		yield put(Actions.toggleUpdatingTask(false));
	}
}

function * taskUpdateFailed({ payload: ex }) {
	yield put(Actions.toggleUpdatingTask(false));
	yield call(eventFailed, { payload: ex });
}

function * eventFailed(action) {
	let message = action.payload.message || action.payload;
	console.log(message);
	yield put(Actions.notify({message}))
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* tasksWatcher() {
  yield* [
		takeEvery(ActionTypes.BEGIN_FETCH_USERS_TASKS, initTasks),
		takeEvery(ActionTypes.REQUEST_UPDATE_TASK, updateTask),
  	takeEvery(ActionTypes.NEW_TASK_SUCCESS, newTaskSuccess),
  	takeEvery(ActionTypes.NEW_TASK_FAILED, eventFailed),
  	takeEvery(ActionTypes.DELETE_TASK_SUCCESS, deleteTaskSuccess),
  	takeEvery(ActionTypes.DELETE_TASK_FAILED, eventFailed),
  	takeEvery(ActionTypes.TASK_UPDATE_SUCCESS, taskUpdateSuccess),
		takeEvery(ActionTypes.EDIT_TASK_SUCCESS, taskUpdateSuccess)
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/tasks.js